import type { DirectusImage } from '@lib/types/directus/directusSchema';

const presets = {
  og: {
    width: 600,
    height: undefined,
    quality: 60,
  },
  articleHeader: {
    width: 585,
    height: 390,
    quality: 90,
  },
};

export default function getImageObject(imageObject: Partial<DirectusImage> | string, preset?: keyof typeof presets) {
  const media = typeof imageObject === 'string' ? { id: imageObject } : imageObject;

  const url = new URL(`https://directus.fauconis.fr/assets/${media.id}`);

  if (preset) {
    const { quality, width, height: targetHeight } = presets[preset];

    const height =
      width && media.height && media.width ? Math.floor((media.height / media.width) * width) : targetHeight;

    if (width) {
      url.searchParams.append('width', width.toString());
    }
    if (height) {
      url.searchParams.append('height', height.toString());
    }
    if (quality) {
      url.searchParams.append('quality', quality.toString());
    }
    url.searchParams.append('format', 'auto');
    url.searchParams.append('fit', 'cover');

    return { url: url.toString(), width, height };
  }

  return { url: url.toString() };
}
